angular
  .module("accordionDigitalSign.components", [])
  .component("accordionDigitalSign", {
    templateUrl:
      "ng/components/accordionDigitalSign/accordionDigitalSign.view.html",
    bindings: {
      userEnabledToDigitalSignature: "<",
      class: "@",
      userPickedDigitalSignature: "&?",
      isLo: "<"
    },
    controllerAs: "accordionDigitalSignCtrl",
    controller: function($configService, $digitalSignatureService) {
      var self = this;

      self.$onInit = function() {
        self.state = {
          userEnabled: false,
          userPickedDigitalSignature: !!self.userEnabledToDigitalSignature ? "true" : "false"
        };

        $digitalSignatureService
            .userAllowedDigitalSignature($configService.getUser().identifier)
            .then(function(res) {
                self.state.userEnabled = !!res.userAllowedToDigitalSignature;
            })

      };

      self.handleChange = function(){
          self.userPickedDigitalSignature({ value: self.state.userPickedDigitalSignature });
      }

    }
  });
